const SANDOS = 1;
const MARCONFORT = 3;

const CHAIN_MAIN_SITE_CONDITIONS = {
  [SANDOS]: {
    es: 'https://www.sandos.com/es/terminos-y-condiciones',
    en: 'https://www.sandos.com/terms-and-conditions',
  },
  [MARCONFORT]: {
    es: '/terms-conditions/es/',
    en: '/terms-conditions/en/',
  },
}

export {
  SANDOS,
  MARCONFORT,
  CHAIN_MAIN_SITE_CONDITIONS,
};
